export default Object.freeze({
  AllCurrentChildren: 1,
  ChildrenStartedBySpecificAction: 2,
});
